'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var WINDOW_ROUTE_CHANGE = 'window:route-change:event';
var WINDOW_BEFORE_UNLOAD = 'window:before-unload:event';

exports.WINDOW_BEFORE_UNLOAD = WINDOW_BEFORE_UNLOAD;
exports.WINDOW_ROUTE_CHANGE = WINDOW_ROUTE_CHANGE;
